
document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict();

    $('.numbers-list li').addClass('swiper-slide');

	var swiper = new Swiper('.numbers-list', {
		speed: 700,
		effect: 'coverflow',
		coverflowEffect: {
			rotate: 30,
			slideShadows: false,
		},
		autoplay: true,
		direction: 'vertical',
		loop: true,
		grabCursor: true,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		pagination: false,
		navigation: false,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 0
	});

	function commaSeparateNumber(num) {
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	$('.numbers-list li.swiper-slide-active em').each( function() {
		var $this = $(this);
		$({ Counter: 0 }).animate({	Counter: $this.text().replace(/,/g, '')}, {
			duration: 500,
			easing: 'swing',
			step: function() { 
				$this.text(commaSeparateNumber(Math.floor(this.Counter)))
			},
			complete: function() {
				$this.text(commaSeparateNumber(this.Counter));
				//alert('finished');
			}
		})
	});

	$('.section_innovation--mob-slider .wp-block-gallery').addClass('swiper-wrapper');
	$('.section_innovation--mob-slider .wp-block-gallery .wp-block-image').addClass('swiper-slide');

	var doorSwiper = new Swiper('.section_innovation--mob-slider', {
		centeredSlides: true,
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: ".swiper-btn-next",
			prevEl: ".swiper-btn-prev",
		},
		grabCursor: true
	});

	window.change = function() {
		var num = document.getElementById('numSlides');
		if (!num || !window.doorSwiper) return;
		num.innerHTML = (doorSwiper.realIndex + 1) + '/' + (doorSwiper.slides.length - 2);
	};

	doorSwiper.on( 'slideChange', function() {
		change();
	});

});